import _ from 'lodash';
import { getRecoil, setRecoil } from 'recoil-nexus';

import state from 'components/state';

const updateManualEntry = (data) => {
  try {
    const newManualEntryState = getRecoil(state.intelligenceAiState);
    if (newManualEntryState?.timeoutTimeout) clearTimeout(newManualEntryState?.timeoutTimeout);
    setRecoil(state.intelligenceAiState, (ps) => ({
      ...ps,
      loading: !!!data?.done,
      response: data?.response,
      ...data
    }));
  } catch (e) {
    console.log(e);
  }
};

export default updateManualEntry;
